


























































































import {
  ref,
  useContext,
  defineComponent,
  useFetch,
  computed,
  watch,
  onMounted,
} from '@nuxtjs/composition-api';
import axios from 'axios';
import ClientOnly from 'vue-client-only';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import { merge } from 'lodash-es';
import { useApi, useUiNotification, useConfig, useWishlist } from '~/composables';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import useLoader from '~/composables/useLoader';
import { CONFIGURABLE_TYPE_ID, META_PDP_SET_NAME } from '~/utils/constants/product';
import AddToCartWrapper from '~/components/solepro/ProductPage/AddToCartWrapper.vue';
import UpSell from '~/components/solepro/ProductPage/UpSell.vue';
import ProductOptions from '~/components/solepro/ProductPage/PurchaseOptions/ProductOptions.vue';
import { getIsBook, getIsPeriodico } from '~/utils/solepro/products';
import { productView, productLinkTrack, productBuyCTATrack } from '~/helpers/trackings/24orepro/products';
import SingleCardPurchaseOptions from '~/components/solepro/ProductPage/PurchaseOptions/SingleCardPurchaseOptions.vue';
import ProductIncipit from '~/components/solepro/ProductPage/ProductIncipit.vue';
import OfflinePurchase from '~/components/solepro/ProductPage/OfflinePurchase.vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import StickyBar from '~/components/solepro/ProductPage/StickyBar.vue';
import PlansBenchmark from '~/components/solepro/ProductPage/PlansBenchmark/PlansBenchmark.vue';
import OfflineBooksPurchase from '~/components/solepro/ProductPage/OfflineBooksPurchase.vue';
import EditorialFixedCta from '~/components/solepro/ProductPage/EditorialFixedCta.vue';
import { getOptionsBlock, getProductMarkup } from '~/utils/helpers/product';
import { GET_AI_CONFIG } from '~/modules/storeConfig/queries/getStoreCategoriesConfig.gql';
import useMeta from '~/composables/useMeta';
import ProductInfoPeriodici from '~/components/solepro/ProductPage/ProductInfoPeriodici.vue'
import ProductInfoLibriECollane from '~/components/solepro/ProductPage/ProductInfoLibriECollane.vue'
import ProductInfo from '~/components/solepro/ProductPage/ProductInfo.vue'
import { getMetaInfo } from '~/helpers/getMetaInfo';
import OfferGroups from '~/components/solepro/ProductPage/PurchaseOptions/OfferGroups/OfferGroups.vue';

import { findCurrentCategory, getBreadcrumbs } from '~/modules/catalog/product/getters/productGetters';
import PurchaseOptionCard from '~/components/solepro/ProductPage/PurchaseOptions/PurchaseOptionCard.vue';
import BundlePurchaseOptionCard from '~/components/solepro/ProductPage/PurchaseOptions/BundlePurchaseOptionCard.vue';
import { manageScroll } from '~/utils/helpers/functions';
import { addBasePath } from '~/helpers/addBasePath';
import { soleproDomain } from '~/utils/constants/hosts';

export default defineComponent({
  name: 'ProductPage',
  components: {
    StickyBar,
    ProductIncipit,
    AddToCartWrapper,
    ProductOptions,
    SingleCardPurchaseOptions,
    UpSell,
    OfflinePurchase,
    OfflineBooksPurchase,
    HTMLContent,
    ClientOnly,
    PlansBenchmark,
    EditorialFixedCta,
    ProductInfoPeriodici,
    ProductInfoLibriECollane,
    ProductInfo,
    OfferGroups,
    PurchaseOptionCard,
    BundlePurchaseOptionCard
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
    sku: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      useDefaultBottomBtn: false
    }
  },
  setup(props) {
    const { send: sendNotification } = useUiNotification();
    const { setIsLoading, isLoading } = useLoader();
    const { app, localePath, $config } = useContext();
    const { load: loadWishlist } = useWishlist();
    loadWishlist()
    const hasFrequencies = ref(false)
    const { i18n } = app;
    const { query } = useApi();
    const { config } = useConfig();
    const { addTags } = useCache();
    const product = ref<ProductForProductPageType | null>(null);
    const cardOptions = ref([]);
    const moreCards = ref([]);
    const moreOptions = ref({})
    const isAiProduct = ref<Boolean>(false)
    const isMetaPDP = ref(false);
    const hasGroups = ref(false);
    const showSuggestedSku = ref(false);
    const isLoadingMore = ref(true);

    const { setMeta, setCanAddMultipleSubProducts } = useMeta();
    const hasFasciaPeriodici = ref(false)
    const productMarkup = ref(null);
    const breadcrumbs = ref([]);
    const placeholderImage = soleproDomain+'/resources/productpage/solepro/product-placeholder.png';

    const trackPageView = async (product) => {
      await productView(product);
      await productLinkTrack(product);
    };

    const trackProductCTA = async (product) => {
      await productBuyCTATrack(product)
    }

    const fetchProductData = async () => {
      setIsLoading(true);
      isLoadingMore.value = true
      const { data: aiData } = await query(GET_AI_CONFIG);
      const AICategory = aiData['storeConfig'].sole_professionisti_ai_category;
      try {
        const splittedRoute = props.slug.split('/product');
        const routeEnding = splittedRoute[1] ? splittedRoute[1] : splittedRoute[0];
        const urlKey = routeEnding.split('.')[0].replace('/', '');
        const queryParams = new URLSearchParams({ urlKey, sku: props.sku }).toString();
        const categoryUid = (app.$vsf.$magento.config.state as any).getCategory();
        
        
        const { data } = await axios.get(`/sole-api/product/getProduct?${queryParams}`, { ...getAxiosConfigs(app, config) });

        let tmp: ProductForProductPageType = merge({}, data as ProductForProductPageType ?? null);
        showSuggestedSku.value = !!tmp?.suggested_sku;
        /** Fetching additionalProducts for MetaPDP and merge inside productModel. */
        hasGroups.value = data?.offer_groups && data?.offer_groups.length > 0
        let additionalProducts = data?.additionalSkus && !hasGroups.value ? await Promise.all(
          (data?.additionalSkus ?? "").split(',').filter(el => !el.match(/^group-/g)).map(async (filter) => {
            const queryParams = new URLSearchParams({ urlKey: null, sku: filter }).toString();
            const { data } = await axios.get(`/sole-api/product/getProduct?${queryParams}`, { ...getAxiosConfigs(app, config) });

            return data

          })
        ) : [];

        tmp = merge(data as ProductForProductPageType, { additionalProducts });


        product.value = tmp;


        if (product.value.more_cards_skus && product.value.more_cards_skus.trim() != '') {
          let moreOptionsStatic = {};
          const params = { skus: product.value.more_cards_skus.replace(/ /g, '').split(',') };
          const { data: moreData } = await axios.post(`/sole-api/product/getProducts`, params, { ...getAxiosConfigs(app, config) });

          if (moreData && moreData.length > 0) {
            moreCards.value = moreData.map(el => {
              return {
                item: el,
                component: (() => {
                  if (el.typeId == CONFIGURABLE_TYPE_ID) {
                    if (el.configurable_options.find(c => c.attribute_code != 'tipo_abbonamento')) {
                      moreOptionsStatic[el.sku] = getOptionsBlock(el)
                    }
                    return 'PurchaseOptionCard'
                    
                  } else {
                    return 'BundlePurchaseOptionCard'

                  }
                })()
              }
            })
          }
          moreOptions.value = Object.assign(moreOptionsStatic)
        }
          isLoadingMore.value = false

        /** Fascia periodici se è periodico ed ha sia il blocco autori che la description oppure se è periodico ma non ha description */
        hasFasciaPeriodici.value = getIsPeriodico(tmp) && ((tmp.area_funzionalita && (tmp.area_funzionalita.includes('autori-block') || tmp.area_funzionalita?.trim() == "") || !tmp.area_funzionalita));
        //isAiProduct.value = !!tmp.categories.find(el => el.id == AICategory)
        /* ProductInfoComponent.value = hasFasciaPeriodici.value ? () => 
         import('~/components/solepro/ProductPage/ProductInfoPeriodici.vue')
           : (getIsBook(tmp) ? () => import('~/components/solepro/ProductPage/ProductInfoLibriECollane.vue') 
           : () => import('~/components/solepro/ProductPage/ProductInfo.vue'))*/

        const category = findCurrentCategory(tmp as any, categoryUid);
        breadcrumbs.value = getBreadcrumbs(
          tmp as any,
          category ? category : null,
        ).map((breadcrumb) => ({ ...breadcrumb, link: `${$config.soleproDomain}${localePath(breadcrumb.link)}` }));

        breadcrumbs.value.unshift({
          text: 'Home',
          link: `${$config.soleproDomain}${localePath('/')}`,
        });

        breadcrumbs.value.pop();

        productMarkup.value = await getProductMarkup(tmp, breadcrumbs.value, $config, placeholderImage)

        const tags = [
          {
            prefix: CacheTagPrefix.View,
            value: `product-${tmp.sku}`,
          },
        ];

        const productTags = [{
          prefix: CacheTagPrefix.Product,
          value: tmp.sku,
        }];

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        addTags([...tags, ...productTags]);


      } catch (e) {
        sendNotification({
          id: Symbol('product_not_found'),
          message: i18n.t('An error occurred retrieving this product') as string,
          type: 'danger',
          icon: 'cross',
          persist: true,
        });
        console.error(e);
      }
      setIsLoading(false);
    };

    useFetch(async () => {
      await fetchProductData();
      isMetaPDP.value = product.value.attributeSetName == META_PDP_SET_NAME;
      cardOptions.value = getOptionsBlock(product.value);
    });

    const isBook = computed(() => {
      return getIsBook(product.value)
    })



    /** END Added */
    const hasOnlyNotBuyable = computed(() => product.value.additionalProducts && product.value.additionalProducts.length > 0
      && product.value.additionalProducts.every(p => !p.buyable))
    watch(isMetaPDP, (newValue) => {
      setCanAddMultipleSubProducts(product.value.canAddMultipleSubproducts)
      setMeta(newValue, newValue ? product.value.additionalSkus.split(',') : [])
    })

    onMounted(() => {
      trackPageView(product.value);
    })

    return {
      product,
      isMetaPDP,
      isLoading,
      isBook,
      breadcrumbs,
      productMarkup,
      trackProductCTA,
      cardOptions,
      hasOnlyNotBuyable,
      isAiProduct,
      /*ProductInfoComponent,*/
      hasFasciaPeriodici,
      hasFrequencies,
      showSuggestedSku,
      hasGroups,
      moreCards,
      moreOptions,
      hasMoreOptions: computed(() => Object.values(moreOptions.value).length > 0),
      isLoadingMore
    };
  },
  methods: {
    setHasFrequencies(val){
      const $t = this as any;// vscode trick @TODO adjust linter
      $t.hasFrequencies = $t.hasFrequencies || val;
    },
    async manageScroll(evt) {
      manageScroll(evt)
      const $t = this as any;// vscode trick @TODO adjust linter
      await $t.trackProductCTA($t.product);
    }
  },
  updated() {
    /**
     * !!! TEMPORARY FIX - WHEN ALL PRODUCT TEMPLATES ARE SANIFIED WE CAN REMOVE THIS LINES
     */
    const headingsAreaPrincipale = Array.from(document.querySelectorAll('#legal_assistant > div > div > div [data-content-type="heading"]')) as HTMLElement[];
    headingsAreaPrincipale.filter(el => el.classList.contains('sm:px-[17%]')).forEach(el => {
      el.classList.remove('sm:px-[17%]')
      el.classList.add('sm:px-[8%]')
    })
    const fasce = Array.from(document.querySelectorAll('#legal_assistant > div > div > div .pagebuilder-column-line')) as HTMLElement[];
    if (fasce.length < 1) return;
    const imgTexts = fasce.filter(el => el.childNodes.length == 2 && el.closest('.pb_column-group').getClientRects().length > 0)
    if (imgTexts.length > 0) {
      imgTexts[0].closest('.pb_column-group').classList.remove('md:py-20')
      imgTexts[0].closest('.pb_column-group').classList.add('pt-0')
      imgTexts[imgTexts.length - 1].closest('.pb_column-group').classList.remove('md:py-20')
      if (imgTexts.length > 1) {
        imgTexts[0].closest('.pb_column-group').classList.add('md:pb-20')
        imgTexts[imgTexts.length - 1].closest('.pb_column-group').classList.add('md:pt-20')
      } else {
        imgTexts[0].closest('.pb_column-group').classList.add('pb-0')
        imgTexts[0].closest('.pb_column-group').classList.add('md:pt-0')
        imgTexts[0].closest('.pb_column-group').classList.add('md:pb-0')
      }
    }

    fasce.forEach(a => {

      /**
       * Fasce 2 colonne img + testo
       */
      const childNodes = Array.from(a.childNodes) as HTMLElement[]

      if (childNodes.length == 3) return;/** 3 cols case */
      if (childNodes.length < 2) return; /** no two cols case */
      let firstCol = childNodes[0].querySelector('[data-content-type="video"]') || childNodes[0].querySelector('[data-content-type="image"]')
      let secondCol = childNodes[1].querySelector('[data-content-type="heading"]')
      if (firstCol && secondCol) {
        childNodes[1].classList.add('gap-4')
        childNodes[1].classList.add('md:gap-5')
        a.classList.remove('gap-5')
        a.classList.add('gap-4')
        a.classList.add('md:gap-5')
        secondCol.closest('.pagebuilder-column').classList.add('gap-y-2');
        (secondCol.closest('.pagebuilder-column') as HTMLElement).style.justifyContent = 'center'
      } else {
        firstCol = childNodes[0].querySelector('[data-content-type="video"]') || childNodes[0].querySelector('[data-content-type="image"]')
        secondCol = childNodes[1].querySelector('[data-content-type="heading"]')
        if (firstCol && secondCol) {
          childNodes[0].classList.add('gap-4')
          childNodes[0].classList.add('md:gap-5')
          a.classList.remove('gap-5')
          a.classList.add('gap-4')
          a.classList.add('md:gap-5')
          firstCol.closest('.pagebuilder-column').classList.add('gap-y-2');
          (firstCol.closest('.pagebuilder-column') as HTMLElement).style.justifyContent = 'center'
        }
      }

    })

    /**
     * Fasce 3 colonne
     */
    //const colsRow = fasce.find(el=>el.childNodes.length == 3 && Array.from(el.childNodes).every((n as HTMLElement)=>n.classList.includes('pagebuilder-column')))
    const colsRows = fasce.filter(el => el.childNodes.length == 3 && (Array.from(el.childNodes) as HTMLElement[]).every(n => n.classList.contains('pagebuilder-column')))

    colsRows.forEach(colsRow => {
      if (colsRow.getClientRects().length < 1) return;
      colsRow.closest('.pagebuilder-column-group').classList.remove('md:px-[8%]')
      colsRow.closest('.pagebuilder-column-group').classList.add('md:px-[4%]')
      colsRow.classList.remove('gap-5')
      colsRow.classList.add('gap-3')
      colsRow.classList.add('md:gap-5')
      const cols = Array.from(colsRow.childNodes) as HTMLElement[]
      try {
        cols[0].classList.remove('pl-3')
        cols[0].classList.remove('md:px-5')
        cols[0].classList.add('md:pl-10')
        cols[0].classList.add('md:pr-0')
        cols[2].classList.remove('md:px-5')
        cols[2].classList.remove('pr-3')
        cols[2].classList.add('md:pr-10')
        cols[2].classList.add('md:pl-0')
      } catch (e) { }
      cols.forEach(col => {
        const text = col.querySelector('.text-xs.leading-120.mt-4')
        if (!!text) {
          text.classList.remove('mt-4')
          text.classList.add('mt-5')
          text.classList.add('md:mt-4')
        }
        const heading = col.querySelector('[data-content-type="heading"]');
        heading && heading.classList.add("break-words");
        const hasImage = !!col.querySelector('img');
        if (!hasImage) {
          heading.classList.remove('mt-4')
          heading.classList.remove('md:mt-6')
        }
      })
    })
  },
  head() {
    return {
      ...getMetaInfo({ ...(this.product as any), title: (this.product as any).name }, false, 'product'),
      script: [
        ...(this.productMarkup as any)
      ]
    }
  },
});
